<div class="ui container-home">
  <div class="ui grid">
    <div class="four  wide column  ">
      <div class="ui card filter" id='card-filter' style='background-color:rgb(249, 249, 249);'>
        <div class="content">
          <div class=" ui left floated header">Filtros
            <i class="filter icon light-blue"></i>
          </div>
          <div class="ui right floated vertical  button" style='padding:1em 1em 1em 1em;
                    ' (click)='list()' tabindex="0">
            <div class="visible content">
              <i class="bars icon view"></i>
            </div>
          </div>
          <div class="ui right floated  vertical  button" style='padding:1em 1em 1em 1em;
                    ' (click)='charts()' tabindex="0">
            <div class="visible content">
              <i class="chart bar icon view"></i>
            </div>
          </div>
        </div>
        <div class="content">
          <form [formGroup]="formDatos" id='form' class="ui form">
            <div class="field " [ngClass]="(mostrarCharts)?'disabled' : ''">
              <label class='label light-blue'>N° OT </label>
              <div class="ui input">
                <select class="ui selection dropdown" formControlName="numero">

                  <option value="">Seleccione:N° OT</option>
                  <option *ngFor="let numero of numeroOtFilters" [value]="numero">{{numero}}
                  </option>
                </select>
              </div>

            </div>
            <div class="field">
             
              <label class='label light-blue'>Planta</label>
              <div class="ui input">
                <select class="ui selection dropdown" formControlName="planta">
                  <option value="">Seleccione:Planta</option>
                  <option *ngFor="let planta of plantas" [value]="planta">{{planta}}
                  </option>
                </select>
              </div>
            </div>


            <div class="field">
            
              <label class='label light-blue'>Descripción</label>
              <div class="ui input">
                <select class="ui selection dropdown" formControlName="descripcion">
                  <option value="">Seleccione:Descripción</option>
                  <option *ngFor="let descripcion of descripciones" [value]="descripcion">{{descripcion  | replaceUnderscore }}
                  </option>
                </select>
              </div>
            </div>
            <div class="field" [ngClass]="(mostrarCharts)?'disabled' : ''">
              <label class='label light-blue'>Estado</label>
              <div class="ui input">
                <select class="ui selection dropdown secciones" formControlName="estado">
                  <option value="">Seleccione:Estado</option>
                  <option *ngFor='let item of estados' [value]="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="field" *ngIf="mostrarCharts">
              <label class='label light-blue'>Año</label>

              <div class="ui input">
                <select class="ui selection dropdown secciones" formControlName="anio">
                  <option value="">Seleccione:Año</option>
                  <option *ngFor='let item of anios' [value]="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="field" [ngClass]="(mostrarCharts)?'disabled' : ''">
              <label class='label light-blue'>Fecha</label>
              <div class="ui input" color="accent" appearance="outline">
                <input formControlName="fecha" type='date' placeholder="29/03/2017">
              </div>
            </div>
            <div class="field" [ngClass]="(mostrarCharts)?'disabled' : ''">
              <label class='label light-blue'>Resultado</label>
              <app-range [from]="from" [to]="to" (change)='onChangeEvent($event)'></app-range>
            </div>
          </form>
        </div>
        <div class="extra content" [ngClass]="(mostrarCharts)?'disabled' : ''">
          <button class="ui right labeled icon button button-filter primary" [disabled]='formDatos.invalid'
            (click)="aplicar()">
            <i class=" check icon"></i>
            APLICAR
          </button>
          <button class="ui right labeled icon button button-filter primary" (click)="limpiar()">
            <i class="trash alternate
                        icon"></i>
            LIMPIAR
          </button>
        </div>
      </div>
    </div>
    <div class="twelve wide column " style="justify-content:center !important;">
      <div class="ui warning message" *ngIf='listRegistros.length === 0 && !spinner  && !mostrarCharts'>
        <i class="close icon"></i>
        <div class="header">
          No se encontraron registros
        </div>
      </div>
      <table style='margin:auto;' class="ui celled selectable table" *ngIf='mostrarLista && listRegistros.length> 0'>
        <thead>
          <tr>
            <th class="center aligned">N° OT</th>
            <th class="center aligned">Planta</th>
            <th class="center aligned">Descripción</th>
            <th class="center aligned">Estado</th>
            <th class="center aligned">Fecha</th>
            <th class="center aligned">Resultado</th>
            <th class="center aligned">Avisos</th>
            <th class="center aligned"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor='let item of listRegistros;index as index ;'>
            <td class="center aligned">
              <p *ngIf="item.Status.OT">{{item.Status.OT.Observed}}</p>
            </td>
            <td class="center aligned">
              <p *ngIf="item.Status.UT">{{item.Status.UT.Observed}}</p>
            </td>
            <td class="center aligned">
              <p *ngIf="item.Protocol_Id">{{item.Protocol_Id}}</p>
            </td>
            <td class="center aligned">
              <p>
                {{item.state}}
              </p>
            </td>
            <td class="center aligned">
              <p *ngIf="item.When">{{item.When | date:'dd/MM/yyyy'}}</p>
            </td>
            <td class="center aligned">
              <div *ngIf="item.state=='Finalizado'">
                <app-spinner-overlay *ngIf="item.score<101 && item.score>90" class="font-optimo" [index]="index"
                  [val]="item.score" color="optimo"></app-spinner-overlay>
                <app-spinner-overlay *ngIf="item.score<91 && item.score>70" class="font-alcanza" [index]="index"
                  [val]="item.score" color="alcanza"></app-spinner-overlay>
                <app-spinner-overlay *ngIf="item.score<71 && item.score>40" [index]="index" [val]="item.score"
                  class="font-no-alcanza" color="no-alcanza">
                </app-spinner-overlay>
                <app-spinner-overlay *ngIf="item.score<41 && item.score>=0" [index]="index" [val]="item.score"
                  class="font-error" color="error">
                </app-spinner-overlay>
              </div>
              <div *ngIf="item.state=='En proceso'">
                <!--<span class="sin-puntaje"> Sin puntaje</span>-->
                <app-spinner-overlay [index]="index" [icon]="true" class="font-gray bold">
                </app-spinner-overlay>
              </div>
            </td>
            <td class="center aligned">
              <p>{{item.cantidadDeAvisoDeMantenimiento}}</p>
            </td>
            <td class="center aligned">
              <div class="ui vertical animated button" tabindex="0" (click)="detalle(item,item.Protocol_Id)">
                <div class="hidden content">Ver </div>
                <div class="visible content">
                  <i class="arrow right icon"></i>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ui link charts" *ngIf='mostrarCharts'>
        <mat-card>
          <div class="scroll">
            <app-bar #graficos [filtros]="filtros" (recargarPlantas)="recargarPlantas($event)"></app-bar>
          </div>

        </mat-card>


      </div>
      <div class="ui grid" *ngIf='pages_total>0 && mostrarLista'>
        <div class="column centered row paginacion">
          <app-paginator #paginacion [pagesTotal]='pages_total' (pageChange)='changePage($event)'>
          </app-paginator>
        </div>
      </div>
    </div>
  </div>
</div>